<ng-lease-track-overage
  *ngIf="(store$ | async) as store"
  [loading]="store.loading"
  [data]="store.leaseTrackOverages"
  [monitoredLeaseTrack]="store.monitoredLeaseTrack"
  [type]="type"
  [printTitle]="printTitle"
  (resetMonitoredTrack)="dispatch()"
></ng-lease-track-overage>
